<template>

    <div class="iwd-modal calendar-modal calendar-wrapper" :class="{initialized: is_initialized, staged: is_staged, unstaging: is_unstaging}" ref="modal-backdrop">
        <div class="modal-inner" :class="{closed: is_closed}">
            <button class="close-modal" @click="close()"></button>

        <calendar-overview-component :context="'modal'"></calendar-overview-component>

        </div>
    </div>

</template>

<script>

var emitter = require('tiny-emitter/instance');

export default {

    data(){
        return {
            is_initialized: false,
            is_staged: false,
            is_unstaging: false,
            is_closed: false
        }
    },
    mounted()
    {
        emitter.on('calendarModalOpening', this.open);

        this.$refs['modal-backdrop'].addEventListener('animationend', (event)=>{
        	if(event.animationName === 'animate-calendar-inner-out')
            {
                this.is_initialized = false;
                this.is_staged = false;
                this.is_unstaging = false;
                this.is_closed = false;
                emitter.emit('calendarModalClosed');
            }
        	if(event.animationName === 'animate-calendar-inner-in')
            {
            	emitter.emit('calendarModalOpened');
            }
        });
    },
    methods: {
    	open()
        {
            this.is_initialized = true;
	        this.$nextTick(()=>{
		        setTimeout(()=>{
		        	this.is_staged = true;
                },1);
	        })
        },
        close()
        {
        	this.is_closed = true;
        	this.is_unstaging = true;
        	setTimeout(()=>{
        		this.$store.commit('setCalendarMode', 'drills');
            },100);
        },
    }

}

</script>
